export const updateSenderID = (builder) => ({
    updateSenderID: builder.mutation({
      query: ({ senderId, action, remark }) => {
        const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
        return {
          url: '/update_sender_id_status',
          method: 'PATCH',
          params: { senderId, action, remark },
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token,
          },
        };
      },
    }),
  });
  